import AppCommandBar from 'app/AppCommandBar'
import { FlexSpinner } from 'components'
import { ViewAuthorizer } from 'components/AccessDenied'
import { StickyPane } from 'components/StickyPane'
import { ProvingGroundsContext } from 'context/ProvingGroundsContext'
import { useCommand } from 'hooks/useCommand'
import { useRouteParams } from 'hooks/useRouteParams'
import { UserRole } from 'model'
import * as React from 'react'
import { useState } from 'react'
import { useReadViewDataQuery } from 'views/AdminResourcesView/AdminResourcesView.generated'
import { AdminMailTemplatesListView } from './AdminMailTemplatesListView'

export interface RouteParamsMailTemplates {
  search: string | undefined
  pgid: string
  id?: string
}

export const AdminMailTemplatesView: React.FC = () => {
  const { loading, data, error } = useReadViewDataQuery()
  const [viewFilterState, setViewFilterState] = useState<string>('')
  const [displayProvingItems, setDisplayProvingItems] = useState(false)
  const provingGrounds = data && data.provingGrounds ? data.provingGrounds : []
  if (!provingGrounds.find((pg) => pg._id === null)) {
    provingGrounds.unshift({
      _id: null,
      abbr: 'ALG',
      title: 'Allgemeine Mailvorlagen',
    } as any)
  }

  const [routeParams, updateRouteParams] =
    useRouteParams<RouteParamsMailTemplates>(
      'admin.data.mailTemplates',
      {
        search: undefined,
        pgid: provingGrounds[0] ? provingGrounds[0]._id : '',
      },
      { persist: ['pgid'] }
    )
  const provingGround =
    provingGrounds.filter((x) => x._id === routeParams.pgid)[0] ||
    provingGrounds[0]

  useCommand(
    {
      priority: 15,
      key: 'provingGround',
      farCommand: true,
      text: provingGround ? provingGround.abbr : '',
      iconProps: { iconName: 'POISolid' },
      subMenuProps: {
        items: provingGrounds.map((pg) => ({
          key: `provingGround-${pg._id}`,
          name: `${pg.title} (${pg.abbr})`,
          onClick: () => {
            updateRouteParams({ pgid: pg._id, search: undefined })
          },
        })),
      },
    },
    [provingGround, provingGrounds, updateRouteParams]
  )

  return (
    <ViewAuthorizer
      roles={[UserRole.ResourceManager, UserRole.SystemAdministrator]}
    >
      <FlexSpinner loading={loading} error={error}>
        <StickyPane>
          <AppCommandBar />
          <ProvingGroundsContext.Provider value={provingGrounds}>
            <React.Suspense fallback={<FlexSpinner />}>
              <AdminMailTemplatesListView
                routeParams={routeParams}
                updateRouteParams={updateRouteParams}
                filterState={viewFilterState}
                setFilterState={setViewFilterState}
                displayProvingItems={displayProvingItems}
                setDisplayProvingItems={setDisplayProvingItems}
              />
            </React.Suspense>
          </ProvingGroundsContext.Provider>
        </StickyPane>
      </FlexSpinner>
    </ViewAuthorizer>
  )
}
